import { AddressDetailPage } from '@/pages/buyer/AddressDetailPage';
import { DesktopAddressDetailPage } from '@/pages/desktop/DesktopAddressDetailPage';
import { BottomNavigation } from '@/components/common/BottomNavigation';

export function ResponsiveAddressDetailPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <AddressDetailPage />
          <BottomNavigation activeId="address" />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopAddressDetailPage />
      </div>
    </>
  );
}